module.exports = __webpack_public_path__ + "static/media/A11.9d3dba53.mp3";